import { gql } from "@apollo/client";

export const CREATE_CUSTOMER_TASK = gql`
  mutation CreateCustomerTaskMutation($input: CreateCustomerTaskInput!) {
    createCustomerTask(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_CUSTOMER_TASK = gql`
  mutation UpdateCustomerTaskMutation($id: Int!, $input: UpdateCustomerTaskInput!) {
    updateCustomerTask(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_CUSTOMER_TASK = gql`
  mutation RemoveCustomerTaskMutation($id: Int!) {
    removeCustomerTask(id: $id) {
      ok
      error
    }
  }
`;

export const CUSTOMER_TASK = gql`
  query CustomerTaskQuery($id: Int!) {
    customerTask(id: $id) {
      ok
      error
      result {
        id
        title
        description
        status
        priority
        customerId
        customer {
          id
          name
        }
        createdBy {
          id
          firstname
          lastname
        }
        assignedTo {
          id
          firstname
          lastname
        }
      }
    }
  }
`;

export const CUSTOMER_TASKS = gql`
  query CustomerTasksQuery($where: CustomerTasksFiltersInput!) {
    customerTasks(where: $where) {
      ok
      error
      total
      results {
        id
        title
        description
        status
        priority
        customerId
        customer {
          id
          name
        }
        createdBy {
          id
          firstname
          lastname
        }
        assignedTo {
          id
          firstname
          lastname
        }
      }
    }
  }
`;
